var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('h1',{staticClass:"mt-5 mb-4 text-xs-center mx-auto headline"},[_vm._v(_vm._s(_vm.msg))]),_c('date-select'),(false)?_c('self-assess'):_vm._e(),(true)?_c('voice-pitch'):_vm._e(),_c('voice-feel-home'),_c('vocal-activity-home'),_c('vocal-naps-home'),_c('water-consumption-home')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-230b21f4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 